import RequestAbstract from "./RequestAbstract";

export default class ClientDocumentsHistory extends RequestAbstract {
    get link() {
        return this.links.clientDocumentsHistory;
    }

    async getForClient(clientId, clinicId) {
        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "clientId", op: "=", value: clientId },
        ];

        return this.getAllFiltered([arr], this.getSortField("id"));
    }

}
